<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：门店-店员列表-添加店员
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加店员-->
      <div class="common-form">修改城市代理</div>
      <el-form-item label="代理账号名称" prop="supplier.name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.name" placeholder="请输入代理账号名称"></el-input>
      </el-form-item>
      <el-form-item label="登录账号" prop="supplier.user_name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.user_name" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="supplier.password" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.supplier.password" placeholder="请输入登录密码" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="supplier.confirm_password" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.supplier.confirm_password" placeholder="请输入确认密码" type="password"
          class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="分成比例" prop="supplier.scale" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.supplier.scale" placeholder="分成比例" 
          class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="supplier.linkName" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.linkName" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="supplier.linkPhone" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.linkPhone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="头像图片">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('logo')">选择图片</el-button>
          <div v-if="form.supplier.logoId != ''" class="img">
            <img :src="logo_filePath" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="选择代理类型">
        <el-radio-group v-model="form.supplier.supplierType">
          <el-radio :label="2">市代</el-radio>
          <el-radio :label="3">区代</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="已代理城市" v-if="form.shopSupplierId != 0">
        <!-- <div v-if="form.agentCityArr">
          <el-tag style="margin-left: 10px;" v-if="form.agentCityArr[0]">{{
      form.agentCityArr[0].name || '暂无'
    }}</el-tag>
        </div> -->
        <div>{{ agentCityArr[0].name }}</div>
      </el-form-item>
      <el-form-item label="代理城市" :rules="[{ required: true, message: ' ' }]">

        <!-- <el-select v-model="form.supplier.agentCityIds" placeholder="请选择" multiple>
          <el-option v-for="(item, index) in citydata" :key="index" :label="item.city" :disabled="item.type"
            :value="item.city_id"></el-option>
        </el-select> -->
        <el-cascader :options="citydata" :props="{ value: 'id', label: 'label', checkStrictly: true }" clearable
          v-model="form.supplier.agentCityIds"></el-cascader>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--管理用户-->
    <GetUser :is_open="open_user" @close="closeDialogFunc($event, 'add')"></GetUser>
  </div>
</template>

<script>
import CityagencyApi from "@/api/cityagency.js";
import Getpoint from "@/components/map/Getpoint.vue";
import Upload from "@/components/file/Upload";
import { formatModel } from "@/utils/base.js";
import GetUser from "@/components/user/GetUser.vue";
export default {
  components: {
    /*上传组件*/
    Upload,
    /*选择用户*/
    GetUser,
    Getpoint
  },
  data() {
    return {
      /*form表单数据*/
      formLabelWidth: "120px",
      form: {
        shopSupplierId: 0,
        supplier: {
          logoId: 0,
          user_name: '',
          password: '',
          name: '',
          confirm_password: '',
          linkName: '',
          linkPhone: '',
          agentCityIds: "",
          scale:'',
          supplierType:''
        }
      },
      logo_filePath: "",
      business_filePath: "",
      /*是否打开添加弹窗*/
      open_add: false,
      storeList: [],
      category: [],
      citydata: [],
      service_type: [],
      /*是否上传图片*/
      isupload: false,
      loading: false,
      type: "logo",
      open_user: false,
      user_info: {},
      agentCityArr: []
    };
  },
  created() {
    this.form.shopSupplierId = this.$route.query.shopSupplierId;
    this.getData();
  },
  methods: {

    /*获取参数*/
    getData() {
      let self = this;
      CityagencyApi.geteditCityagency(
        {
          shopSupplierId: self.form.shopSupplierId
        },
        true
      )
        .then(res => {
          console.log(res, "获取的数据");
          if (res.data.model.agentCityArr) {
            self.agentCityArr = res.data.model.agentCityArr
          }

          self.form.supplier = formatModel(self.form.supplier, res.data.model);
          // self.form.supplier.scale=res.data.model.scale
          if (res.data.model.logo) {
            self.logo_filePath = res.data.model.logo.file_url;
          }
          self.citydata = res.data.data.map(item => {
            if (item.type == 1) {
              return { ...item, type: false };
            } else {
              return { ...item, type: true };

            }
          });
          self.citydata.forEach((item, index) => {
           item.children = item.citys
            item.label = item.province
            item.id = item.provinceId
            if (item.children) {
              item.children.forEach(subItem => {
                subItem.children = subItem.regions
                subItem.label = subItem.city
                subItem.id = subItem.cityId
                if (subItem.children) {
                  subItem.children.forEach(yItem => {
                    yItem.label = yItem.name
                  })
                }
              })
            }
          })
          // self.citydata = res.data.data;
          // console.log("===========res.data.data", res.data.data);

          self.form.supplier.agentCityIds = [];
          res.data.model.agentCityIds.forEach(item => {
            self.form.supplier.agentCityIds.push(Number(item));
          });

          if (res.data.model.superUser) {
            self.form.supplier.userId = res.data.model.superUser.userId;
            self.form.supplier.userName = res.data.model.superUser.userName;
            // self.user_info.avatarUrl = res.data.model.superUser.user.avatarUrl;
          }
        })
        .catch(error => { });
    },

    /*添加用户*/
    onSubmit() {
      let self = this;
      let agentCityIds = ''
      // let supplierType=2
      let mylength = 0
      
      if (this.form.supplier.agentCityIds.length == 0) {
        this.$message({
          message: "请选择市级或区级城市代理",
          type: "error"
        });
        return
      }
      if (this.form.supplier.agentCityIds) {
        mylength = this.form.supplier.agentCityIds.length
        console.log(mylength, '长度1')
        if (mylength <= 1) {
          this.$message({
            message: "请选择市级或区级城市代理",
            type: "error"
          });
          return
        } else {
          // console.log(this.form.supplier.agentCityIds[mylength - 1])
          // agentCityIds = this.form.supplier.agentCityIds[mylength - 1]
          // console.log(789,mylength)
          // if (mylength == 2) {
          //   console.log(123)
          //   self.form.supplierType = 2
          // } else {
          //   self.form.supplierType = 3
          // }
          agentCityIds = this.form.supplier.agentCityIds[mylength - 1]
          // console.log(agentCityIds)
          console.log(mylength)
          if (self.form.supplier.supplierType == 2) {
            if (mylength != 2) {
              self.$message({
                message: "您的代理类型为市级代理，请选择市级城市",
                type: "error"
              });
              return
            }
          }
          if (self.form.supplier.supplierType == 3) {
            if (mylength != 3) {
              self.$message({
                message: "您的代理类型为区级代理，请选择区级城市",
                type: "error"
              });
              return
            }
          }
        }

      }
      console.log( self.form.supplierType)
           
      // let agentCityIds = "";
      // if (self.form.supplier.agentCityIds.length > 0) {
      //   agentCityIds = self.form.supplier.agentCityIds.join(",");
      // } else {
      //   agentCityIds = "";
      // }
      let form = self.form.supplier;
      form.agentCityIds = agentCityIds;
      form.supplierType=self.form.supplierType
      // let form = self.form.supplier;
      form.shopSupplierId = self.form.shopSupplierId;
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CityagencyApi.editCityagency(form, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: "恭喜你，修改成功",
                  type: "success"
                });
                self.$router.push("/cityagency/cityagency/index");
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.type == "logo") {
          this.logo_filePath = e[0].filePath;
          this.form.supplier.logoId = e[0].fileId;
        } else if (this.type == "business") {
          this.business_filePath = e[0].filePath;
          this.form.supplier.business_id = e[0].fileId;
        }
      }
      this.isupload = false;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*打开弹出层*/
    userClick() {
      this.open_user = true;
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc(e) {
      if (e.type != "error") {
        this.user_info = e.params[0];
        this.form.supplier.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {}

.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/cityagency/cityagency/edit.vue